import React, { useState } from 'react';
import { calendarType, displayDate, displayRange, sortedBreaks } from './calendarPresentation';
import SchoolCalendarBreaks from './SchoolCalendarBreaks';
import './schoolCalendar.scss';

const months = ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'];
const weekdays = ['Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So', 'Nd'];

export default function SchoolCalendarView({ calendar }) {
  const [selectedDate, setSelectedDate] = useState(null);
  const breaks = sortedBreaks(calendar.breaks);
  const namesOn = date => breaks.filter(item => item.fromDate <= date && date <= item.tillDate).map(item => item.name).join(', ');
  const selectedNames = selectedDate && namesOn(selectedDate);
  const period = calendar.teachingPeriod;
  return (
    <div className="school-calendar">
      <header className="school-calendar-panel">
        <span className="school-calendar-readonly">Tylko do odczytu</span>
        <h2>Kalendarz szkoły</h2>
        <p>Rok szkolny {calendar.schoolYearStart}/{calendar.schoolYearStart + 1}</p>
        {calendar.integrationPending && <p>Kalendarz informacyjny — daty nie zmieniają jeszcze planu lekcji ani rozliczeń.</p>}
        {calendar.status === 'updating' && <p>Trwa aktualizacja kalendarza. Poniżej ostatnia opublikowana wersja.</p>}
        {period ? <p>Okres prowadzenia zajęć: <strong>{displayRange(period)}</strong></p>
          : <p>Kalendarz na ten rok nie został jeszcze skonfigurowany.</p>}
      </header>
      {period && (
        <div className="school-calendar-layout">
          <section className="school-calendar-year school-calendar-panel" aria-label="Kalendarz roku szkolnego">
            <p className="school-calendar-legend"><span>Przerwy i dni wolne</span><span>Poza okresem zajęć</span></p>
            <div className="school-calendar-months">
              {Array.from({ length: 12 }, (_, index) => {
                const month = (index + 8) % 12;
                const year = calendar.schoolYearStart + (index >= 4 ? 1 : 0);
                const first = new Date(Date.UTC(year, month, 1));
                const offset = (first.getUTCDay() + 6) % 7;
                const count = new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
                const rows = Math.ceil((offset + count) / 7);
                return (
                  <table key={`${year}-${month}`} className="school-calendar-month">
                    <caption>{months[month]} {year}</caption>
                    <thead><tr>{weekdays.map(day => <th key={day} scope="col">{day}</th>)}</tr></thead>
                    <tbody>{Array.from({ length: rows }, (_, week) => (
                      <tr key={`${year}-${month}-${week}`}>
                        {weekdays.map((weekday, dayIndex) => {
                          const day = week * 7 + dayIndex - offset + 1;
                          if (day < 1 || day > count) return <td key={weekday} />;
                          const date = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
                          const names = namesOn(date);
                          const outside = date < period.fromDate || date > period.tillDate;
                          return (
                            <td key={weekday} className={outside ? 'school-calendar-outside' : ''}>
                              {names ? (
                                <button type="button" aria-label={`${displayDate(date)} — ${names}`} aria-pressed={date === selectedDate}
                                  className="school-calendar-break-day" onClick={() => setSelectedDate(date)}>{day}</button>
                              ) : <time dateTime={date} title={outside ? 'Poza okresem zajęć' : undefined}>{day}</time>}
                            </td>
                          );
                        })}
                      </tr>
                    ))}</tbody>
                  </table>
                );
              })}
            </div>
            <p role="status" aria-live="polite" className="school-calendar-selection">
              {selectedNames ? `${displayDate(selectedDate)} — ${selectedNames}` : 'Wybierz oznaczony dzień, aby zobaczyć nazwę przerwy.'}
            </p>
          </section>
          <aside className="school-calendar-list school-calendar-panel" aria-label="Przerwy i dni wolne">
            <h3>Przerwy i dni wolne</h3>
            <SchoolCalendarBreaks calendar={calendar} />
          </aside>
        </div>
      )}
    </div>
  );
}
SchoolCalendarView.propTypes = { calendar: calendarType.isRequired };
